// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"403130d7","879":"d4d76619"}[chunkId] + ".chunk.js";
};